import { Place } from '@witkac/kartamiejska-shared';
import { PlaceResource, placeResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';
/**
 * Moduł obiektów
 *
 * @export
 * @class PlacesModule
 * @extends {EntityModule<Place, PlaceResource>}
 */
export class PlacesModule extends EntityModule<Place, PlaceResource> {
  constructor() {
    super(placeResource);
  }
}

export default new PlacesModule();
